import React from "react";
import { useTranslation } from "react-i18next";
import { Props, MailInboxUploaderOptionValue } from "./interfaces";

import { QuickFilterOption } from "src/reusable-components/QuickFilter/interfaces";
import QuickFilter from "src/reusable-components/QuickFilter/QuickFilter";

export const MailInboxUploaderQuickfilter = ({ allUploaders, quickFilters, handleChangeQuickFilters }: Props) => {
  const { t } = useTranslation();
  const tRP = "components.quickfilters.mail_inbox_uploaders";

  const quickFilter: keyof MailInboxUploaderOptionValue = "mailInboxUploaders";
  const quickFilterOptionValueKey: keyof MailInboxUploaderOptionValue = "mailInboxUploaderIds";

  const options: QuickFilterOption<MailInboxUploaderOptionValue>[] = [
    {
      name: t(`common_words.all`),
      value: {
        mailInboxUploaderIds: [],
      },
    },
    ...allUploaders.map((uploader) => ({
      name: uploader.name,
      value: {
        mailInboxUploaderIds: [uploader.id],
      },
    })),
  ];

  return (
    <>
      <QuickFilter
        options={options}
        quickFilters={quickFilters}
        quickFilter={quickFilter}
        handleChangeQuickFilter={handleChangeQuickFilters}
        shrinkedLabel={t(`${tRP}.shrinked_label`)}
        isMultiSelect
        multiSelectField={quickFilterOptionValueKey}
        customTextFieldStyle={
          {
            maxWidth: "350px",
            "& .MuiAutocomplete-input": {
              minWidth: "120px !important",
            },
          } as React.CSSProperties
        }
      />
    </>
  );
};
